import "client-only";

import {
  ChartModelSchema,
  type ChartModel,
  type GenerateChartRequest,
} from "@/contracts/charts";
import { client } from "@/lib/platform/client";

async function generate(request: GenerateChartRequest): Promise<ChartModel> {
  return client.post("/api/charts/generate?format=json", request, {
    expect: ChartModelSchema,
  });
}

export const charts = { generate };
